import { useNavigate, useSearch } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

import { DISCOUNT_PANES, discountPane, discountPaneSearch, DISCOUNTS_COPY as T, type DiscountPane } from "./discounts";
import { PartnersPane } from "./PartnersPane";
import { SubscriptionsPane } from "./SubscriptionsPane";

/**
 * The Discounts tab (C1 v1.8, editors from C1 v1.22, item5): the page head, then v26's two panes as a segmented control,
 * Subscriptions (the default) and Distribution Partners, the pane in the URL (`pp_dpane`) as the other tabs' panes. Each pane reads
 * only what it shows and says on its own when a read fails. Every write control is left unmarked, so the shell's PermissionGate makes
 * it inert for a view-only person and C2 refuses the write anyway; the controls that change nothing carry `data-nonmutating`.
 */
export function DiscountsTab({ areaName }: { areaName: string }) {
  const search = useSearch({ strict: false }) as Record<string, unknown>;
  const navigate = useNavigate();
  const pane = discountPane(search);
  const go = (next: DiscountPane) => void navigate({ to: ".", search: discountPaneSearch(search, next), replace: true });
  return (
    <div className="flex flex-col gap-4">
      <div className="page-head"><h2 className="text-lg font-semibold text-ks-ink">{T.title}</h2><p className="text-sm text-ks-grey-1">{T.desc}</p></div>
      <div role="group" aria-label="Pane" className="flex gap-1">
        {DISCOUNT_PANES.map((key) => (
          <Button key={key} size="sm" variant={key === pane ? "default" : "outline"} aria-pressed={key === pane} data-nonmutating onClick={() => go(key)}>
            {T.panes[key]}
          </Button>
        ))}
      </div>
      {pane === "subscriptions" ? <SubscriptionsPane areaName={areaName} /> : <PartnersPane areaName={areaName} />}
    </div>
  );
}
